"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uStreamApps = exports.radianToDegree = exports.isIDNotSet = exports.getSecondsFromDuration = exports.getRectangleTopLeft = exports.getMsFromDuration = exports.getDurationFromSeconds = exports.getDurationFromMs = exports.getCreationSecurityData = exports.degreeToRadian = exports.convertToTopLeftPositionPct = exports.appPermisionsHasApp = exports.ZORDER_NOT_SET = exports.ZORDER_MIN = exports.ZORDER_MAX = exports.ZORDER_DEFAULT = exports.STRINGID_NOT_SET = exports.QUARTER_SCALING = exports.POSITION_TOP_RIGHT_QUADRANT = exports.POSITION_TOP_LEFT_QUADRANT = exports.POSITION_FULL = exports.POSITION_CENTER_HALF_SIZE = exports.POSITION_BOTTOM_RIGHT_QUADRANT = exports.POSITION_BOTTOM_LEFT_QUADRANT = exports.NOT_SET_VALUE = exports.HALF_SCALING = exports.FULL_SCALING = exports.EMPTY_USERFUL_SECURITY_DATA = exports.APP_NAMES = exports.APP_IDS = exports.ANGLE_DEGREES_90 = exports.ANGLE_DEGREES_270 = exports.ANGLE_DEGREES_180 = exports.ANGLE_DEGREES_0 = exports.ALPHA_TRANSPARENT = exports.ALPHA_OPAQUE = exports.ALPHA_DEFAULT = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _globalStates = require("../globalstates/globalStates");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NOT_SET_VALUE = exports.NOT_SET_VALUE = "NOT_SET";
var STRINGID_NOT_SET = exports.STRINGID_NOT_SET = {
  value: NOT_SET_VALUE
};
var isIDNotSet = exports.isIDNotSet = function isIDNotSet(value) {
  return !value || value.value === NOT_SET_VALUE;
};
var EMPTY_USERFUL_SECURITY_DATA = exports.EMPTY_USERFUL_SECURITY_DATA = function EMPTY_USERFUL_SECURITY_DATA() {
  return {
    id: STRINGID_NOT_SET,
    userID: NOT_SET_VALUE,
    userName: NOT_SET_VALUE,
    securityDataSet: false,
    clearanceLevelPermissions: [],
    userClearanceLevelPermissions: []
  };
};

// epoch seconds

var getSecondsFromDuration = exports.getSecondsFromDuration = function getSecondsFromDuration(durationValue) {
  if (!durationValue) {
    return 0;
  }
  if (isNaN(durationValue)) {
    return _moment["default"].duration(durationValue).asSeconds();
  }
  return Number(durationValue);
};
var getMsFromDuration = exports.getMsFromDuration = function getMsFromDuration(durationValue) {
  if (!durationValue) {
    return 0;
  }
  if (isNaN(durationValue)) {
    return _moment["default"].duration(durationValue).asMilliseconds();
  }
  return Number(durationValue) * 1000;
};
var getDurationFromMs = exports.getDurationFromMs = function getDurationFromMs(ms) {
  return _moment["default"].duration(Number(ms), "milliseconds").toISOString();
};
var getDurationFromSeconds = exports.getDurationFromSeconds = function getDurationFromSeconds(s) {
  return _moment["default"].duration(Number(s), "seconds").toISOString();
};
var degreeToRadian = exports.degreeToRadian = function degreeToRadian(value) {
  return value * Math.PI / 180;
};
var radianToDegree = exports.radianToDegree = function radianToDegree(value) {
  return value * 180 / Math.PI;
};
var ANGLE_DEGREES_0 = exports.ANGLE_DEGREES_0 = {
  radians: degreeToRadian(0.0)
};
var ANGLE_DEGREES_90 = exports.ANGLE_DEGREES_90 = {
  radians: degreeToRadian(90.0)
};
var ANGLE_DEGREES_270 = exports.ANGLE_DEGREES_270 = {
  radians: degreeToRadian(270.0)
};
var ANGLE_DEGREES_180 = exports.ANGLE_DEGREES_180 = {
  radians: degreeToRadian(180.0)
};
var getRectangleTopLeft = exports.getRectangleTopLeft = function getRectangleTopLeft(data) {
  return {
    x: data.center.x - data.size.width / 2,
    y: data.center.y - data.size.height / 2
  };
};
var HALF_SCALING = exports.HALF_SCALING = 50.0;
var FULL_SCALING = exports.FULL_SCALING = 100.0;
var QUARTER_SCALING = exports.QUARTER_SCALING = 25.0;
var ZORDER_NOT_SET = exports.ZORDER_NOT_SET = {
  value: 0
};
var ZORDER_DEFAULT = exports.ZORDER_DEFAULT = {
  value: 1
};
var ZORDER_MIN = exports.ZORDER_MIN = {
  value: Number.MIN_SAFE_INTEGER
};
var ZORDER_MAX = exports.ZORDER_MAX = {
  value: Number.MAX_SAFE_INTEGER
};
var ALPHA_OPAQUE = exports.ALPHA_OPAQUE = {
  value: 1.0
};
var ALPHA_TRANSPARENT = exports.ALPHA_TRANSPARENT = {
  value: 0.0
};
var ALPHA_DEFAULT = exports.ALPHA_DEFAULT = ALPHA_OPAQUE;
var convertToTopLeftPositionPct = exports.convertToTopLeftPositionPct = function convertToTopLeftPositionPct(centerPostion) {
  return {
    x: centerPostion.center.x - centerPostion.size.width / 2,
    y: centerPostion.center.y - centerPostion.size.height / 2
  };
};
var POSITION_FULL = exports.POSITION_FULL = {
  center: {
    x: HALF_SCALING,
    y: HALF_SCALING
  },
  size: {
    width: FULL_SCALING,
    height: FULL_SCALING
  },
  rotation: ANGLE_DEGREES_0,
  zorder: ZORDER_DEFAULT,
  alpha: ALPHA_DEFAULT
};
var POSITION_TOP_LEFT_QUADRANT = exports.POSITION_TOP_LEFT_QUADRANT = {
  center: {
    x: QUARTER_SCALING,
    y: QUARTER_SCALING
  },
  size: {
    width: HALF_SCALING,
    height: HALF_SCALING
  },
  rotation: ANGLE_DEGREES_0,
  zorder: ZORDER_DEFAULT,
  alpha: ALPHA_DEFAULT
};
var POSITION_TOP_RIGHT_QUADRANT = exports.POSITION_TOP_RIGHT_QUADRANT = {
  center: {
    x: QUARTER_SCALING + HALF_SCALING,
    y: QUARTER_SCALING
  },
  size: {
    width: HALF_SCALING,
    height: HALF_SCALING
  },
  rotation: ANGLE_DEGREES_0,
  zorder: ZORDER_DEFAULT,
  alpha: ALPHA_DEFAULT
};
var POSITION_BOTTOM_LEFT_QUADRANT = exports.POSITION_BOTTOM_LEFT_QUADRANT = {
  center: {
    x: QUARTER_SCALING,
    y: QUARTER_SCALING + HALF_SCALING
  },
  size: {
    width: HALF_SCALING,
    height: HALF_SCALING
  },
  rotation: ANGLE_DEGREES_0,
  zorder: ZORDER_DEFAULT,
  alpha: ALPHA_DEFAULT
};
var POSITION_BOTTOM_RIGHT_QUADRANT = exports.POSITION_BOTTOM_RIGHT_QUADRANT = {
  center: {
    x: QUARTER_SCALING + HALF_SCALING,
    y: QUARTER_SCALING + HALF_SCALING
  },
  size: {
    width: HALF_SCALING,
    height: HALF_SCALING
  },
  rotation: ANGLE_DEGREES_0,
  zorder: ZORDER_DEFAULT,
  alpha: ALPHA_DEFAULT
};
var POSITION_CENTER_HALF_SIZE = exports.POSITION_CENTER_HALF_SIZE = {
  center: {
    x: HALF_SCALING,
    y: HALF_SCALING
  },
  size: {
    width: HALF_SCALING,
    height: HALF_SCALING
  },
  rotation: ANGLE_DEGREES_0,
  zorder: ZORDER_DEFAULT,
  alpha: ALPHA_DEFAULT
};
// app name to ID
var APP_IDS = exports.APP_IDS = {
  Decisions: "ControlRoom",
  Engage: "Engage",
  SDK: "SDK",
  Trends: "Trends",
  Artistic: "Engage",
  Notification: "Notifications",
  Spaces: "Spaces",
  Remote: "OPStreams",
  Switch: "Launcher",
  Calibration: "Calibration",
  Launcher: "Launcher",
  Config: "Config",
  uConduct: "uConduct",
  uControl_License: "uControl",
  GCM: "GCM",
  EdgeAI: "EdgeAI"
};
var appPermisionsHasApp = exports.appPermisionsHasApp = function appPermisionsHasApp(appPermissions, appID) {
  if (!appPermissions || !appPermissions.valid || appPermissions.appIDs.length < 1) {
    return true;
  }
  return appPermissions.appIDs.findIndex(function (a) {
    return a.value === appID;
  }) >= 0;
};

// app ID to name
var APP_NAMES = exports.APP_NAMES = {
  ControlRoom: "Decisions",
  Engage: "Engage",
  Trends: "Trends",
  Artistic: "Engage",
  SDK: "SDK",
  Notification: "Notifications",
  Notifications: "Notifications",
  Spaces: "Spaces",
  Remote: "OPStreams",
  Switch: "uControl",
  Launcher: "uControl",
  uConduct: "uConduct",
  GCM: "Global Cluster Manager",
  SD: "Sources & Destinations",
  Admin: "Admin Center",
  EdgeAI: "Infinity EdgeAI"
};

// SUCCESS,		// The operation succeeded.
// COMPOSITE,		// This severity depends on the severities of the child responses.
// INFO,			// Contains information about an abnormal but non-fatal issue.
// WARN,			// Warning of some issue or inconsistency that may cause a problem but might be recovered.
// FATAL,			// A fatal error that cannot be recovered.
// CHILD,			// The response severity should be obtained from the child.
// UNKNOWN;		// Unknown.

var uStreamApps = exports.uStreamApps = function uStreamApps(userPermission) {
  var ids = [];
  if (userPermission.uStreamDecisionAdmin) {
    ids.push(APP_IDS.Decisions);
  }
  if (userPermission.uStreamEngageAdmin) {
    ids.push(APP_IDS.Engage);
  }
  if (userPermission.uStreamTrendsAdmin) {
    ids.push(APP_IDS.Trends);
  }
  return ids;
};
var getCreationSecurityData = exports.getCreationSecurityData = function getCreationSecurityData(data) {
  return data.clearanceLevelPermissions.length !== 0 ? _objectSpread(_objectSpread({}, data), {}, {
    userName: (0, _globalStates.getGlobalStates)().userData.userName,
    userID: (0, _globalStates.getGlobalStates)().userData.userID.value,
    securityDataSet: true
  }) : data;
};